/**
 * ewa-favorites-tracking.js — GA4 + Klaviyo analytics for the favorites/wishlist.
 *
 * Listens to the `ewa:favorites-updated` event dispatched by ewa-favorites.js.
 * The event detail is shaped:
 *   { count, action: 'add'|'remove', item: { productId, productHandle, variantId, properties, propertiesHash } }
 * Note the product fields are nested under `item` — not flat on `detail`.
 *
 * gtag (GA4) and klaviyo are loaded by their app embeds; this file never injects
 * them and no-ops cleanly when either is absent.
 */
(function () {
  'use strict';

  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function sendGA4(action, item) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', action === 'add' ? 'add_to_wishlist' : 'remove_from_wishlist', {
      currency: currency(),
      items: [
        {
          item_id: item.productId,
          item_variant: item.variantId,
        },
      ],
    });
  }

  function sendKlaviyo(action, item) {
    var k = window.klaviyo;
    if (!k || typeof k.track !== 'function') return;
    k.track(action === 'add' ? 'Wishlist Added' : 'Wishlist Removed', {
      ProductID: item.productId,
      ProductHandle: item.productHandle,
      VariantID: item.variantId,
      Properties: item.properties || {},
    });
  }

  document.addEventListener('ewa:favorites-updated', function (event) {
    var detail = event.detail || {};
    var item = detail.item;
    // `count`-only updates (e.g. a bulk clear) carry no item — nothing to attribute.
    if (!item || !item.variantId) return;

    var action = detail.action === 'remove' ? 'remove' : 'add';
    sendGA4(action, item);
    sendKlaviyo(action, item);
  });
})();
